import React, { useEffect } from "react";
import SectionToggle from "../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/dailyPulseSagas";
import { useDispatch, useSelector } from "react-redux";
import ReactDatePicker from "../../components/reactDatePicker/reactDatePicker";
import { SECTIONS } from "./constants";
import { withLoadingAnimation } from "./HOCs/withLoadingAnimation";
import { learnMore } from "./smartComponents/dailyPulseLearnMore";

const allSections = SECTIONS.map(({ Component, key, urn, ...rest }) => {
  const Section = withLoadingAnimation(Component, key, urn);
  // eslint-disable-next-line react/display-name
  return (notifications, showChart) =>
    showChart[key] ? <Section key={key} notifications={notifications} {...rest} /> : null;
});

const DailyPulseModule = ({ showChart, ...restProps }) => {
  const date = useSelector((state) => state.dailyPulse.date);
  const { notifications } = useSelector((state) => state.commonReducer.commonProps);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(restProps));
  }, []);

  const updateDates = (date) => dispatch(actionCreators.updateDate(date));

  const content = () => {
    return (
      <div className="dailyPulse">
        <div className="edit-selections-bar">
          <div className="date-select-box">
            <p className="offers-title">Date</p>
            <ReactDatePicker
              startDate={date ? date : restProps.calendarEndDate}
              calendarEndDate={restProps.calendarEndDate}
              minDate={restProps.calendarStartDate}
              updateDates={updateDates}
            />
          </div>
        </div>

        <>{allSections.map((section) => section(notifications, showChart))}</>
      </div>
    );
  };
  return (
    <SectionToggle title="Daily Pulse" hideToggle learnMore={learnMore()} content={content()} />
  );
};

export default DailyPulseModule;
